var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWeatherHotTemperature = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 13,
  height: 21,
  fill: "none",
  viewBox: "0 0 12.983 21"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  fillRule: "evenodd",
  d: "M5 0a2 2 0 0 1 2 2v2.522a2.36 2.36 0 0 1 1.483-.494q1.023.001 1.739.716.716.716.716 1.74-.001 1.021-.716 1.738a2.37 2.37 0 0 1-1.739.716A2.36 2.36 0 0 1 7 8.443v2.973A5.001 5.001 0 0 1 5 21a5 5 0 0 1-2-9.584V2a2 2 0 0 1 2-2m0 9a.5.5 0 0 0-.5.5v4.565A1.999 1.999 0 1 0 7 16c0-.932-.638-1.712-1.5-1.935V9.5A.5.5 0 0 0 5 9m3.892 1.983h-.818V9.347h.818zm3.058-1.626-.583.603-1.136-1.176.553-.552zm1.033-2.464h-1.636v-.819h1.636zM11.95 3.589l-1.156 1.155-.563-.562 1.146-1.176zm-3.058.03h-.818V1.983h.818z",
  clipRule: "evenodd"
})));
export default SvgWeatherHotTemperature;